<template>
    <div v-loading="fullscreenLoading" element-loading-background="rgba(255, 255, 255, 0.4)">
        <el-form :label-position="left" :inline="true" size="mini" label-width="80px" :model="formInline" class="demo-form-inline">
            <el-row>
                <el-form-item label="类目名称">
                    <el-select v-model="formInline.name" placeholder="请选择" clearable>
                        <el-option value="" label="全部">
                        </el-option>
                        <el-option v-for="item in selectList" :key="item.ID" :label="item.NAME" :value="item.NAME">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="类目顺序" prop="sort">
                    <el-input v-model="formInline.sort" clearable></el-input>
                </el-form-item>
                <el-form-item label="类目状态">
                    <el-select v-model="formInline.status" placeholder="请选择" clearable>
                        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-row>
            <el-row>
                <el-col :span="18" style="text-align:center">
                    <el-button size="mini" type="primary" @click="search" icon="el-icon-search">搜索</el-button>
                    <el-button size="mini" type="primary" @click="add" icon="el-icon-circle-plus-outline">新增分类</el-button>
                </el-col>
            </el-row>
        </el-form>
        <el-table size="mini" ref="multipleTable" :data="tableData3" tooltip-effect="dark" style="width:100%;" :row-class-name="classCallback">
            <el-table-column label="序号" type="index" :index="indexMethod" width="55px">
            </el-table-column>
            <el-table-column prop="name" label="类目名称">
            </el-table-column>
            <el-table-column prop="sort" label="类目顺序">
            </el-table-column>
            <el-table-column prop="status" label="类目状态">
                <template slot-scope="scope">
                    {{scope.row.status==1?'启用':'停用'}}
                </template>
            </el-table-column>
            <el-table-column prop="rowCrtTs" label="创建日期 ">
                <template slot-scope="scope">
                     {{scope.row.rowCrtTs | formatDate("yyyy-MM-dd hh:mm:ss")}}
                </template>     
            </el-table-column>
            <el-table-column prop="address" label="操作"  width="240px">
                <template slot-scope="scope">
                    <el-button size="mini" type="primary" @click="togg(scope.row)">
                        {{scope.row.status==0?'启用':'停用'}}
                    </el-button>
                    <el-button size="mini" type="primary" @click="edit(scope.row)">
                        修改
                    </el-button>
                    <el-button size="mini" type="primary" @click="deleted(scope.row.id)">
                        删除
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <br />
        <div class="block">
            <el-pagination class="right" @current-change="handleCurrentChange" :current-page="formInline.pageNo" :page-size="10" layout="total, prev, pager, next, jumper" :total="page.total">
            </el-pagination>
        </div>
        <el-dialog v-loading="fullscreenLoading_" :title="title" :visible.sync="dialogVisible" width="500px">
            <el-form :model="ruleForm" size="mini" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                <el-form-item label="类目名称" prop="name">
                    <el-input v-model="ruleForm.name"></el-input>
                </el-form-item>
                <el-form-item label="类目顺序" prop="sort">
                    <el-input v-model="ruleForm.sort"></el-input>
                </el-form-item>
                <el-form-item label="备注" prop="memo">
                    <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4}" placeholder="请输入内容" v-model="ruleForm.memo">
                    </el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button size="mini" @click="dialogVisible = false">取 消</el-button>
                <el-button size="mini" type="primary" @click="Submit">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { baseurl } from "../../../base.js";
import Eve from "../../../components/common/emit.js";
export default {
    mounted() {
        this.load();
        this.select();
        Eve.$on("categoryList", this.load);
    },
    data() {
        let validatePass2 = (rule, value, callback) => {
            if (value === "") {
                return callback();
            }
            let reg = /^\d{0,3}$/;
            if (!reg.test(value)) {
                return callback(new Error("最大输入3位数字！"));
            }
            callback();
        };
        var kongge = (rule, value, callback) => {
            console.log(value,222)
            if (value === "") {
                callback();
            } else {
                let str = /^\S{1,10}$/;
                if (!str.test(value)) {
                    callback(new Error("最小1个，最大10个字符"));
                } else {
                    callback();
                }
            }
        };
        return {
            title: "添加",
            ruleForm: {
                name: "",
                sort: "",
                memo: ""
            },
            rules: {
                name: [
                    {
                        required: true,
                        message: "请输入正确的类目名称",
                        trigger: "change"
                    },
                    { validator: kongge, trigger: "blur" }
                ],
                sort: [{ validator: validatePass2, trigger: "change" }],
                memo: [
                    {
                        max: 50,
                        message: "最多50个字",
                        trigger: "blur"
                    }
                ]
            },
            dialogVisible: false,
            selectList: [],
            options: [
                {
                    value: "",
                    label: "全部"
                },
                {
                    value: "0",
                    label: "停用"
                },
                {
                    value: "1",
                    label: "启用"
                }
            ],
            baseurl: baseurl,
            fullscreenLoading: false,
            fullscreenLoading_: false,
            page: {
                total: 0
            },
            left: "left",
            tableData3: [],
            formInline: {
                name: "",
                sort: "",
                status: "",
                pageNo: 1,
                size: 10
            }
        };
    },
    methods: {
        classCallback(obj) {
            if (obj.row.status != 1) {
                return "iS-active";
            } else {
                return "b";
            }
        },
        select() {
            this.$http.post(`/v/category/all`,{ 
                platCode:localStorage.getItem("platCode"),
                merId:localStorage.getItem("merId") 
            }).then(data => {
                this.selectList = data.data;
            });
        },
        indexMethod(index) {
            return (this.formInline.pageNo - 1) * 10 + index + 1;
        },
        Submit() {
            this.$refs["ruleForm"].validate(valid => {
                if (valid) {
                    this.fullscreenLoading_ = true;
                    let url = !!this.ruleForm.id
                        ? "/v/category/modify"
                        : "/v/category/add";
                    this.$http.post(url, this.ruleForm).then(
                        data => {
                            Eve.$emit("categoryListChange");
                            this.fullscreenLoading_ = false;
                            this.dialogVisible = false;
                            this.load();
                            this.select();
                            this.$message({
                                type: "success",
                                message: "操作成功"
                            });
                        },
                        () => {
                            this.fullscreenLoading_ = false;
                        }
                    );
                }
            });
        },
        add() {
            this.$refs["ruleForm"] && this.$refs["ruleForm"].resetFields();
            for (var i in this.ruleForm) {
                this.ruleForm[i] = "";
            }
            this.title = "添加";
            this.dialogVisible = true;
        },
        edit(obj) {
            this.$refs["ruleForm"] && this.$refs["ruleForm"].resetFields();
            this.title = "修改";
            this.dialogVisible = true;
            for (var i in obj) {
                this.ruleForm[i] = obj[i];
            }
        },
        deleted(id) {
            this.$confirm("您确定删除当前类目及该类目下所有菜品吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(() => {
                this.$http.post(`/v/category/del/${id}`).then(data => {
                    this.load();
                    this.$message({
                        type: "success",
                        message: "删除成功"
                    });
                });
            });
        },
        togg(obj) {
            let data = {
                status: obj.status == 0 ? 1 : 0
            };
            this.$http
                .post(`/v/category/status/${obj.id}`,{status:data.status})
                .then(data => {
                    this.load();
                    this.$message({
                        type: "success",
                        message: "修改成功"
                    });
                });
        },
        handleCurrentChange(index) {
            this.formInline.pageNo = index;
            this.load();
        },
        load() {
            let reg = /^[1-9][0-9]{0,}$/g;
            if (!!this.formInline.sort && !reg.test(this.formInline.sort)) {
                return this.$notify.error({
                    title: "错误",
                    message: "排序必须是大于0的整数！"
                });
            }         
            this.fullscreenLoading = true;
            this.$http
                .post(
                    `/v/category/s?pageNumber=${this.formInline.pageNo}&pageSize=${
                        this.formInline.size
                    }`,
                    this.formInline
                )
                .then(data => {
                    this.fullscreenLoading = false;
                    this.tableData3 = data.data;
                    this.page.total = data.pageable.totalElements;
                })
                .catch(error => {
                    this.fullscreenLoading = false;
                });
        },
        search() {
            this.formInline.pageNo = 1;
            this.load();
        }
    }
};
</script>

<style scoped>
.right {
    text-align: right;
}
</style>


// WEBPACK FOOTER //
// src/view/page/classify/classify.vue